import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, throwMatDialogContentAlreadyAttachedError } from '@angular/material';
import {ActivatedRoute, Router} from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { UserService } from '../../core/user.service';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-performance-modal',
  templateUrl: './performance-modal.component.html',
  styleUrls: ['./performance-modal.component.css']
})
export class PerformanceModalComponent implements OnInit {
  projectId: any;
  hostUrl;
  type:any;
  configAzure: any;
  activeStatusAzure: boolean;
  myFormAzure: any;
  azureData: any;
  serverId: any;
  addStatus: any;
  isDb = false;
  
  constructor(private dialogRef: MatDialogRef<PerformanceModalComponent>,	
     	@Inject(MAT_DIALOG_DATA) public data: String,private http: HttpClient, private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute, private userService: UserService) { 

    this.myFormAzure = new FormGroup({
      tenent_id: new FormControl(''),
      client_id: new FormControl(''),
      client_secret: new FormControl(''),
      subscription_id: new FormControl(''),
      resource_group: new FormControl(''),
      resource_name: new FormControl(''),
      service_name: new FormControl(''),
      database_name: new FormControl(''),

      threshold: new FormControl(''),
      memthreshold: new FormControl('')
    });
   }

  ngOnInit() {
    this.hostUrl=this.userService.getUrl();
    
   this.getDetails();
  }
   getDetails(){
    this.azureData = this.data;
    //this.configAzure = this.azureData.tabledata;
    this.projectId = this.azureData.projectId;
    this.serverId = this.azureData.serverId;
    this.addStatus = this.azureData.addServer;
    this.http.get(encodeURI(this.hostUrl+'/configure/azureConfigServer/' + this.projectId +'/'+this.serverId))
    .subscribe(data => {
       this.configAzure = data;
       console.log(this.configAzure)
       this.myFormAzure.controls.threshold.setValue(this.configAzure.threshold)
       this.myFormAzure.controls.service_name.setValue(this.configAzure.service_name)
        this.myFormAzure.controls.database_name.setValue(this.configAzure.database_name)
        this.myFormAzure.controls.tenent_id.setValue(this.configAzure.tenent_id)
        this.myFormAzure.controls.client_id.setValue(this.configAzure.client_id)
        this.myFormAzure.controls.client_secret.setValue(this.configAzure.client_secret)
        this.myFormAzure.controls.subscription_id.setValue(this.configAzure.subscription_id)
        this.myFormAzure.controls.resource_group.setValue(this.configAzure.resource_group)
        this.myFormAzure.controls.resource_name.setValue(this.configAzure.resource_name)
        this.myFormAzure.controls.memthreshold.setValue(this.configAzure.memthreshold)
       
   });
 
    this.activeStatusAzure = true;
    }
   onSubmitAzure(form: FormGroup) {
   if(this.addStatus === 'true'){
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    this.http.post(encodeURI(this.hostUrl+'/configure/addAzure/' + this.projectId ), form.value, {headers: headers})
       .subscribe(()=> {
         this.toastr.success('Added Successfully', 'Success ', {
           timeOut: 2000
         });
        });
   }else if(this.addStatus === 'false')
  {
    let headers = new HttpHeaders();
     headers = headers.append('Content-Type', 'application/json');
     this.http.post(encodeURI(this.hostUrl+'/configure/updateAzure/' + this.projectId + '/' + this.serverId ), form.value, {headers: headers})
        .subscribe(()=> {
         this.toastr.success('Updated Successfully', 'Success ', {
            timeOut: 2000
          });
         });
    
  }
 
   }
  
  }





// WEBPACK FOOTER //
// ./src/app/_models/performance-modal/performance-modal.component.ts